import './css/main.css'
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import fadeImages from "./js/fadeImages";

Alpine.plugin(intersect)

Alpine.data('fadeImages', fadeImages)

window.Alpine = Alpine
Alpine.start()
